import { Box } from "@mui/system";
import styled from "styled-components";
export const Status = styled(Box)`
  position: absolute;
  top: 15px;
  right: 15px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  color: ${({ type, theme }) =>
    type === 1 ? theme.color.primary : theme.color.secondary};
  font-size: 12px;
  font-weight: 600;
  padding: 6px 8px;
  background: ${({ theme }) => theme.color.white};
  border-radius: 3px;
  text-transform: uppercase;
`;
